import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { delay, Observable, of } from 'rxjs';
import { ApiConfiguration } from '../api-configuration';
import { BaseService } from '../base-service';
import { ConfigurationSettings } from '../models/configuration-settings';
import { CreateSensorModel, SensorModel } from '@admin/settings/sensor-model-table/sensor-model';
import { BannerSettings } from '@app/admin/settings/settings.model';

@Injectable({
  providedIn: 'root',
})
export class GlobalConfigurationApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  static readonly GlobalConfigurationPath = '/globalConfiguration';

  getSettings(): Observable<any> {
    return this.http.get<ConfigurationSettings>(`${this.rootUrl}${GlobalConfigurationApi.GlobalConfigurationPath}`);
  }

  updateSettings(params): Observable<any> {
    return this.http.put<ConfigurationSettings>(`${this.rootUrl}${GlobalConfigurationApi.GlobalConfigurationPath}`, params);
  }

  // GET /GlobalConfiguration/banners-settings
  getBannerConfig(): Observable<BannerSettings> {
    return this.http.get<BannerSettings>(`${this.rootUrl}${GlobalConfigurationApi.GlobalConfigurationPath}/banners-settings`);
  }

  getSensorModels(): Observable<SensorModel[]> {
    return this.http.get<SensorModel[]>(`${this.rootUrl}${GlobalConfigurationApi.GlobalConfigurationPath}/sensor-models`);
  }

  addSensorModel(payload: CreateSensorModel): Observable<SensorModel> {
    return this.http.post<SensorModel>(`${this.rootUrl}${GlobalConfigurationApi.GlobalConfigurationPath}/sensor-models`, payload);
  }

  removeSensorModel(id: number): Observable<void> {
    return this.http.delete<void>(`${this.rootUrl}${GlobalConfigurationApi.GlobalConfigurationPath}/sensor-models/${id}`);
  }

  setDefaultSensorModel(id: number): Observable<void> {
    return this.http.put<void>(`${this.rootUrl}${GlobalConfigurationApi.GlobalConfigurationPath}/sensor-models/${id}/default`, null);
  }
}